import {useCallback} from "react";
import {FilterTypes} from "../constans/filter";
import {ParamTypes} from "../constans/paramTypes";

export function useSQLTableFilterType() {
    return useCallback((type) => {
        switch (type) {
            case ParamTypes.AGE:
            case ParamTypes.AMOUNT:
            case ParamTypes.DAYS:
            case ParamTypes.INDEX:
            case ParamTypes.WEIGHT:
                return FilterTypes.NUMBER;
            case ParamTypes.BOOLEAN:
                return FilterTypes.BOOLEAN;
            case ParamTypes.MEDICINE:
                return FilterTypes.MEDICINE;
            case ParamTypes.PARTURITION_LEVEL:
                return FilterTypes.PARTURITION_LEVEL;
            case ParamTypes.RACE:
                return FilterTypes.RACE;
            case ParamTypes.RACE_CODE:
                return FilterTypes.RACE_CODE;
            case ParamTypes.REASON:
                return FilterTypes.FALL_REASON;
            case ParamTypes.RESULT:
                return FilterTypes.USG_RESULT;
            case ParamTypes.SOW_STATE:
                return FilterTypes.SOW_STATE;
            case ParamTypes.SUPPLIER:
                return FilterTypes.SUPPLIER;
            case ParamTypes.TECHNOLOGY_GROUP_REMOVAL:
                return FilterTypes.TECHNOLOGY_GROUP_REMOVAL;
            case ParamTypes.TIME:
                return FilterTypes.DATE;
            default:
                return FilterTypes.STRING;
        }
    }, []);
}
